import React from "react";
import ChartCoin from "./Chart2";
import ChartPoint from "./Chart1";

const Chart = () => {
  return (
    <section className="section_space pb-5  bg-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <ChartCoin />
          </div>
          <div className="col-lg-6">
            <ChartPoint />
          </div>
          <p className="text-center mt-4" style={{color: "#000000"}}>
            These charts are for illustration purposes only and represent how
            promotional rewards are structured in the TopCoin UK loyalty
            programme. They do not represent investment growth, financial
            returns, or cash interest.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Chart;
